import "bootstrap/dist/css/bootstrap.min.css";
import "./App.scss";
import Featured from "./Components/Featured/Featured";
import Partners from "./Components/Partners/Partners";
import Hero from "./Components/Hero/Hero";
import Navbar from "./Components/Navbar/Navbar";
import Supporting from "./Components/Supporting/Supporting";
import Cta from "./Components/CTA/Cta";
import Faq from "./Components/FAQs/Faq";
import Footer from "./Components/Footer/Footer";
import FrameTool from "./Components/FrameTool/FrameTool";
import Team from "./Components/Team/Team";

function App() {
  return (
    <div className="App">
      <Navbar />

      <Hero />
      <Supporting />
      <div className="sectionmerge">
        <Featured />
        <Partners />
      </div>
      <Cta />
      <FrameTool />
      <Team />
      <Faq />
      <Footer />
    </div>
  );
}

export default App;
